import store from "../store/index"
import {axiosApi, uploadApi} from "./api"
import {dayEnd, dayStart, yearStart, yearEnd, monthStart, monthEnd} from '../util/DateUtil'
import Axios from "axios"

/**
 * API 列表
 * @type {function(*=): *}
 */

// 获取计费概况
export const GET_V3_Room_List_Page = function (data) {
    return axiosApi("get", `/v3/cost/room/list/page/${1}/${20}`)({
        ...data,
        projectId: store.getters.projectId,
        // true 分页 false 不分页
        pageFlag: false
    })
}

// 导出表计模板
export const GET_V3_Cost_Export_Meter_Template = function () {
    return axiosApi("get", "/v3/cost/export/meter/template")({
        projectId: store.getters.projectId
    })
}

// 导入表计模板
export const UPLOAD_COST_IMPORT_METER_TEMPLATE = file => {
    let data = new FormData()
    data.append("file", file)
    data.append("projectId", store.getters.projectId)
    return uploadApi("/v3/cost/import/meter/template")(data)
}

// 导入租户企业信息
export const UPLOAD_COST_IMPORT_ENTERPRISE_TEMPLATE = file => {
    let data = new FormData()
    data.append("file", file)
    data.append("projectId", store.getters.projectId)
    return uploadApi("/v3/cost/import/enterprise/template")(data)
}

// 账单管理
export function PUT_V3_Cost_Enterprise_Charges_Details(data) {
    return axiosApi("get", "/v3/cost/enterprise/charges/details")(data)
}

// 收据记录
export function PUT_V3_Cost_Tenant_Recharge_Page(current, size, data) {
    return axiosApi("get", `/v3/cost/tenant/recharge/page/${current}/${size}`)({
        ...data,
        projectId: store.getters.projectId
    })
}

// 电表状态数量
export function GET_V3_Cost_Meter_Status_Totals() {
    return axiosApi("get", "/v3/cost/meter/status/totals")({
        projectId: store.getters.projectId
    })
}

// 收入基本信息
export function GET_V3_Cost_Details() {
    return axiosApi("get", "/v3/cost/details")({
        projectId: store.getters.projectId
    })
}

// 租户管理
export function GET_V3_Cost_Enterprise_List_Page(current, size, data) {
    return axiosApi("get", `/v3/cost/enterprise/list/page/${current}/${size}`)({
        ...data,
        projectId: store.getters.projectId
    })
}

// 新增 / 更新租户
export function POST_V3_Cost_Enterprise_SaveOrUpdate(data) {
    return axiosApi("post", "/v3/cost/enterprise/saveOrUpdate")({
        ...data,
        projectId: store.getters.projectId
    })
}

// 删除租户
export function POST_V3_Cost_Enterprise_Delete(id) {
    return axiosApi("post", "/v3/cost/enterprise/delete")({
        id
    })
}

// 修改电价
export function POST_V3_Cost_ElectricPrice(data) {
    return axiosApi("post", "/v3/cost/electricPrice")({
        ...data,
        userId: store.state.homeitem.user.uid
    })
}

// 验证房间密码
export function GET_V3_Cost_Room_Valid_Password(data) {
    return axiosApi("get", "/v3/cost/room/valid/password")({
        ...data,
        projectId: store.getters.projectId
    })
}

// 销户退租
export function PUT_V3_Cost_Enterprise_Renting_Out(id) {
    return axiosApi("put", "/v3/cost/enterprise/renting/out")({
        id
    })
}

// 查询房间租户
export function GET_V3_Cost_Room_Tenant_List(id) {
    return axiosApi("get", "/v3/cost/room/tenant/list")({
        roomId: id
    })
}

// 租户解绑
export function GET_V3_Cost_Room_Tenant_Unbind(data) {
    return axiosApi("get", "/v3/cost/room/tenant/unbind")(data)
}